import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import {AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW0C00Component } from './kymw0c00.component';

import { GetPCodeDataService } from './api-services/get-pcode-data.service';
import { GetSupplierNameService } from './api-services/get-supplier-name.service';
import { GetImageNameService } from './api-services/get-image-name.service';
import { GetImageInfoService } from './api-services/get-image-info.service';
import { GetImageTypeLimitService } from './api-services/get-image-type-limit.service';
import { GetImageGroupInfoService } from './api-services/get-image-group-info.service';
import { UpdateImageInfoService } from './api-services/update-image-info.service';
import { GetSampleOrderingOutputService } from './api-services/get-sample-ordering-output.service';
import { KYMW0400Module } from '../../kymw04/kymw0400/kymw0400.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ReferenceImageFileUploadService } from './api-services/reference-image-file-upload.service';


/**
 * 画像作成指示画面 モジュール設定クラス
 *
 * @export KYMW0C00Module
 * @class KYMW0C00Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
    KYMW0400Module,
    FontAwesomeModule
  ],
  declarations: [
    KYMW0C00Component,
  ],
  providers: [
    GetPCodeDataService,
    GetSupplierNameService,
    GetImageNameService,
    GetImageInfoService,
    GetImageTypeLimitService,
    GetImageGroupInfoService,
    UpdateImageInfoService,
    GetSampleOrderingOutputService,
    ReferenceImageFileUploadService,
  ],
})
export class KYMW0C00Module {
}
